const recaptchaConfig = {
    actions: {
        login:'login',
        addcard:'addcard',
        purchase:'purchase',
        registration:'registration',
    },
}

export default recaptchaConfig